import type { ReactNode } from 'react';

export const symbol_chess_rook: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M220-80q-24.75 0-42.37-17.63Q160-115.25 160-140v-106q0-12.6 5.44-23.72Q170.89-280.84 181-289q66-57 105.5-126.5T351-573h-48q-24 0-42-18t-18-42v-217q0-12.75 8.63-21.38Q260.25-880 273-880h124q12.75 0 21.38 8.62Q427-862.75 427-850v93h106v-93q0-12.75 8.63-21.38Q550.25-880 563-880h124q12.75 0 21.38 8.62Q717-862.75 717-850v217q0 24-18 42t-42 18h-48q25 88 64.5 157.5T779-289q10.11 7.86 15.56 18.93Q800-259 800-246v106q0 24.75-17.62 42.37Q764.75-80 740-80H220Zm0-60h520v-101q-87-79-131.5-171.5T547-573H412q-17 68-61.5 160.5T220-241v101Zm83-493h354v-187h-64v123H367v-123h-64v187Zm0 0h354-354Zm177 493Z"
		/>
	</svg>
);
